import { SortOrder } from "@avenueops/shared-types";
import { Popover, PopoverTrigger, PopoverContent, Button } from "@avenueops/web-components";
import { ArrowsUpDownIcon } from "@heroicons/react/24/outline";
import { useProcessTableSort } from "context/ProcessTableContext";
import { getColumnNameFromId } from "../utils/ProcessTableColumnsUtils";

export function ProcessTableSortView() {
  const [sort, setSort] = useProcessTableSort();

  return sort.length && sort.length > 0 ? (
    <Popover>
      <PopoverTrigger>
        <div className="rounded bg-primary-light text-gray-700 font-medium text-sm flex flex-row gap-1 py-1 px-4 items-center h-[32px]">
          <ArrowsUpDownIcon className="h-5 w-5" />
          <div>{`Sorted by ${sort.length} field${sort.length === 1 ? "" : "s"}`}</div>
        </div>
      </PopoverTrigger>
      <PopoverContent align="end">
        <div className="flex flex-col gap-2">
          <div className="text-gray-500 uppercase font-bold">Sort by</div>
          {sort.map((s, index) => {
            return (
              <div key={index} className="w-full flex flex-row justify-between gap-2">
                <div className="font-medium">{getColumnNameFromId(s.column)}</div>
                <div>{s.order === SortOrder.ASC ? "ASC" : "DESC"}</div>
              </div>
            );
          })}
          <div className="flex justify-end pt-5">
            <Button
              size="SMALL"
              type="SECONDARY"
              onClick={() => {
                setSort([]);
              }}
            >
              Clear All
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  ) : null;
}
